import { useEffect, useState } from 'react';

import { useForgotPassword } from '@refinedev/core';

import {
  Button,
  Loading,
  Typography,
  useSnackbar,
} from '@rrexpress/core';
import { useDocumentTitle } from '@refinedev/react-router-v6';

import BluebirdImage from '@/assets/images/bluebird.svg';
import { BaseForm } from '@/components/form/form';
import FormField from '@/components/form/form-field';
import { RenderIf } from '@/components/conditional/render-if';

export const ForgotPassword = () => {
  const setTitle = useDocumentTitle();
  const { mutate, isLoading } = useForgotPassword();
  const { show } = useSnackbar();
  const [isSuccess, setIsSuccess] = useState(false);

  const footerButton = () => (
    <Button
      className="w-full"
      variant="primary"
    >
        Dapatkan Link
    </Button>
  );

  function handleOnSubmit(values: { email_or_phone_number: string }) {
    mutate(values, {
      onSuccess: () => {
        show('Link reset password telah dikirim ke alamat email anda', 'success');
        setIsSuccess(true);
      },
      onError: (error: any) => {
        show('Gagal mengirim link reset password', 'error');
      },
    });
  }

  useEffect(() => {
    setTitle('Forgot Password | Bluebird Kirim');

    return () => {
      setTitle('Bluebird Kirim');
    };
  }, []);

  return (
    <div className="container mx-auto h-[100vh] flex flex-col items-center justify-center">
      <div className="p-8 text-black lg:min-w-[30vw]">
        {isLoading && (
          <Loading
            variant="circular"
            size={40}
            speed={0.6}
            indicatorCap="round"
          />
        )}
        <div className={`flex flex-col justify-center text-center ${isLoading && 'hidden'}`}>
          <img src={BluebirdImage} className="w-[180px] mx-auto mb-4" />
          <RenderIf
            condition={isSuccess}
            fallback={(
              <>
                <div className="mb-2">
                  <Typography level={3} fontWeight="medium">Lupa dengan passwordmu?</Typography>
                </div>
                <div className="mb-4">
                  <Typography level={6} fontWeight="regular">Masukkan email terdaftar untuk mendapatkan link atur ulang password.</Typography>
                </div>
                <div className="my-2 text-grey">
                  <BaseForm
                    onFinish={handleOnSubmit}
                    footer={footerButton()}
                  >
                    <div className="mb-4">
                      <FormField
                        id="email_or_phone_number"
                        component="form"
                        name="email_or_phone_number"
                        componentProps={{
                          className: 'w-full',
                          type: 'email',
                          label: 'Masukan Email',
                          required: true,
                        }}
                      />
                    </div>
                  </BaseForm>
                </div>
              </>
            )}
          >
            <div className="mb-4">
              <Typography level={6} fontWeight="regular">Link berhasil dikirim, silahkan cek email Anda.</Typography>
            </div>
          </RenderIf>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
